import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (id,setValues) => {
    fetch(ApiUrl.LabAdminPrint_Jobcard_Order+"/"+id,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        console.log(data);
        setValues(data.response);
    });
}

const Functions = {Get};
export default Functions;